'use client'
import { Link } from '@/i18n/routing'
import classNames from 'classnames'
import { ComponentProps, FC } from 'react'

type NavLinkProps = {
  href: ComponentProps<typeof Link>['href']
  title: string
  isActive?: boolean
  isHovered?: boolean
}

const NavLink: FC<NavLinkProps> = ({ href, title, isActive = false }) => {
  const navLinkClassName = 'py-[18px] px-6 rounded-[25px] m-0 leading-[11px] font-[500] transition-colors duration-150'
  return (
    <Link href={href} className={classNames(navLinkClassName, isActive ? 'text-selected-nav-tag' : 'text-white bg-transparent border-none', 'relative z-10')}>
      {title}
    </Link>
  )
}

export default NavLink
